<!-- <p>requisition-edit works!</p> -->
<!-- <div class="popup-overlay"> -->
<div class="popup-overlay">
    <!-- Header -->
    <div class="popup-header">
        <h3 class="popup-title">Edit Requisition</h3>
        <button class="close-button" (click)="onClose()">&times;</button>
    </div>

    <!-- Step Navigation -->
    <div class="step-navigation">
        <div class="step-item" [class.active]="currentStep === 1" [class.completed]="currentStep > 1"
            (click)="goToStep(1)">
            <div class="step-number">1</div>
            <div class="step-label">Requisition Details</div>
        </div>
        <div class="step-divider"></div>
        <div class="step-item" [class.active]="currentStep === 2" [class.completed]="currentStep > 2"
            (click)="goToStep(2)">
            <div class="step-number">2</div>
            <div class="step-label">Training Schedule</div>
        </div>
        <div class="step-divider"></div>
        <div class="step-item" [class.active]="currentStep === 3" (click)="goToStep(3)">
            <div class="step-number">3</div>
            <div class="step-label">Additional Information</div>
        </div>
    </div>

    <!-- Content Area -->
    <div class="popup-content">
        <form [formGroup]="requisitionForm">

            <!-- Step 1: Requisition Details -->
            <div class="step-content" *ngIf="currentStep === 1">
                <div class="four-col-row">
                    <div formGroupName="requisition">
                        <label class="fw-semibold">Enquiry No.</label>
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Enter Enquiry No</mat-label>
                            <input matInput formControlName="enquiryId" type="text" (blur)="onEnquiryIdBlur()">
                        </mat-form-field>
                    </div>

                    <div formGroupName="requisition">
                        <label class="fw-semibold">Document No.</label>
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>REQ-0001</mat-label>
                            <input matInput formControlName="docNo">
                        </mat-form-field>
                    </div>

                    <div formGroupName="requisition">
                        <label class="fw-semibold">Document Date</label>
                        <mat-form-field appearance="outline" class="w-100">
                            <input matInput [(ngModel)]="docDateString" [ngModelOptions]="{standalone: true}" type="date">
                        </mat-form-field>
                    </div>

                    <div formGroupName="customerDetails">
                        <label class="fw-semibold">Customer Name</label>
                        <div class="flex-row">
                            <mat-form-field appearance="outline" class="my-select-box" style="flex:1">
                                <mat-label>Customer Name</mat-label>
                                <mat-select formControlName="customerId"
                                    (selectionChange)="updateCustomerSelections($event)">
                                    <mat-option *ngFor="let c of customers" [value]="c.id">{{c.name}}</mat-option>
                                </mat-select>
                            </mat-form-field>

                            <!-- <button class="my-btn btn-sm" title="Add New Customer" (click)="openAddCustomerModal()">
                                +
                            </button> -->
                        </div>
                    </div>

                    <div formGroupName="customerDetails">
                        <label class="fw-semibold">Customer Type</label>
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Customer Type</mat-label>
                            <mat-select formControlName="customerType">
                                <mat-option *ngFor="let type of customerTypes" [value]="type.type">{{ type.type }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div formGroupName="customerDetails">
                        <label class="fw-semibold">GST No.</label>
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>GST number</mat-label>
                            <input matInput [disabled]="true" formControlName="customerGstNumber" type="text">
                        </mat-form-field>
                    </div>

                    <div formGroupName="customerDetails">
                        <label class="fw-semibold">Contact Person</label>
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Contact person name</mat-label>
                            <input matInput formControlName="contactPersonName" type="text">
                        </mat-form-field>
                    </div>

                    <div formGroupName="customerDetails">
                        <label class="fw-semibold">Contact No.</label>
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Contact number</mat-label>
                            <input matInput formControlName="contactPersonNumber" type="tel">
                        </mat-form-field>
                    </div>

                    <div formGroupName="customerDetails">
                        <label class="fw-semibold">Email ID</label>
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Email address</mat-label>
                            <input matInput formControlName="contactPersonEmail" type="email">
                        </mat-form-field>
                    </div>

                    <div formGroupName="customerDetails" style="grid-column: span 3">
                        <label class="fw-semibold">Billing Address</label>
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Full billing address</mat-label>
                            <textarea matInput formControlName="customerAddress" class="textarea"></textarea>
                        </mat-form-field>
                    </div>
                </div>
            </div>

            <!-- Step 2: Training Schedule -->
            <div class="step-content" *ngIf="currentStep === 2">

                <!-- Tab Navigation -->
                <div class="schedule-tabs">
                    <div class="tab-header">
                        <button type="button" class="my-btn" *ngFor="let schedule of schedules.controls; let i = index"
                            [class.active]="activeTabIndex === i" (click)="setActiveTab(i)">
                            {{ schedule.get('title')?.value || 'Batch ' + (i + 1) }}
                        </button>
                        <button type="button" mat-stroked-button color="primary" (click)="addSchedule()"
                            title="Add new schedule">
                            +
                        </button>
                        <!-- Optional: Add remove button for current tab -->
                        <button type="button" mat-stroked-button color="warn"
                            *ngIf="schedules.length > 1" (click)="removeCurrentSchedule()"
                            title="Remove current schedule">
                            ×
                        </button>
                    </div>
                </div>

                <!-- Tab Content Container -->
                <div formArrayName="trainingSchedules" class="tab-content-container">
                    <!-- Loop through all schedules but show only the active one -->
                    <div *ngFor="let schedule of schedules.controls; let i = index" class="schedule-item tab-panel"
                        [class.active]="activeTabIndex === i" [formGroupName]="i">

                        <!-- Basic Information -->
                        <div>
                            <!-- class="form-row" -->
                            <!-- <div>
                                    <label [for]="'title-' + i">Batch Title</label>
                                    <input type="text" [id]="'title-' + i" matInput formControlName="title"
                                        placeholder="Batch title">
                                </div> -->
                            <div class="two-col-row" style="grid-template-columns: auto 1fr">
                                <div>
                                    <label [for]="'title-' + i">Batch Title</label>
                                </div>
                                <div>
                                    <mat-form-field appearance="outline" class="w-100">
                                        <mat-label>Batch title</mat-label>
                                        <input matInput type="text" [id]="'title-' + i" formControlName="title">
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                        <!-- Update the collapsible panel section in your HTML template -->

                        <div class="collapsible-panel">
                            <button class="collapsible-header" (click)="togglePanel()"
                                [class.active]="getCurrentTabPanelState()">
                                <span class="toggle-icon">{{ getCurrentTabPanelState() ? '−' : '+' }} Class
                                    session</span>
                            </button>
                            <div class="collapsible-content" [class.open]="getCurrentTabPanelState()">

                                <!-- calendar section -->
                                <div class="form-row">
                                    <div>
                                        <div class="calendar-section">
                                            <!-- <label class="form-label" [for]="'schCalendar' + i">Class Session</label> -->
                                            <div class="calendar-header">
                                                <button (click)="previousMonth()" class="nav-btn">&lt;</button>
                                                <h3>{{ getMonthYear() }}</h3>
                                                <button (click)="nextMonth()" class="nav-btn">&gt;</button>
                                            </div>

                                            <div class="calendar-grid">
                                                <div class="day-header" *ngFor="let day of dayHeaders">{{ day }}</div>

                                                <div *ngFor="let date of getCurrentTabCalendarDates(); let j = index"
                                                    class="calendar-date" [class.other-month]="!date.isCurrentMonth"
                                                    [class.selected]="isDateSelected(date.date)"
                                                    [class.in-range]="isDateInRange(date.date)"
                                                    [class.range-start]="isRangeStart(date.date)"
                                                    [class.range-end]="isRangeEnd(date.date)"
                                                    [class.disabled]="isPastDate(date.date)"
                                                    (mousedown)="!isPastDate(date.date) && startDateSelection($event, date.date)"
                                                    (mouseenter)="!isPastDate(date.date) && onDateHover(date.date)"
                                                    (mouseup)="!isPastDate(date.date) && endDateSelection(date.date)">

                                                    {{ date.date.getDate() }}
                                                </div>
                                            </div>

                                        </div>

                                        <!-- Time Selection Modal remains the same -->
                                        <div class="modal-overlay" *ngIf="showTimeModal" (click)="closeTimeModal()">
                                            <div class="time-modal" (click)="$event.stopPropagation()">
                                                <h3>Set Training Time</h3>
                                                <div class="time-inputs" [formGroup]="timeSelectionForm">
                                                    <div class="time-group">
                                                        <label>Start Time:</label>
                                                        <input type="time" 
                                                            class="time-input" formControlName="startTime">
                                                    </div>
                                                    <div class="time-group">
                                                        <label>End Time:</label>
                                                        <input type="time" class="time-input"
                                                            formControlName="endTime">
                                                    </div>
                                                    <div class="time-group">
                                                        <label>Training Title (Optional):</label>
                                                        <input type="text" class="text-input"
                                                            placeholder="Enter training title"
                                                            formControlName="trainingTitle">
                                                    </div>
                                                </div>
                                                <div class="modal-buttons">
                                                    <button (click)="saveTimeSelection()"
                                                        class="save-btn my-btn">Save</button>
                                                    <button (click)="closeTimeModal()"
                                                        class="cancel-btn my-btn">Cancel</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="selected-schedules" *ngIf="getCurrentTabDateRanges().length > 0">
                                    <h5>Scheduled Sessions</h5>
                                    <ul>
                                        <li *ngFor="let range of getCurrentTabDateRanges()">
                                            <strong>{{ range.Title || '' }}</strong>
                                            : {{ range.StartDate | date:'MMM d, y' }} → {{ range.EndDate | date:'MMM d,
                                            y' }}
                                            ({{ range.StartTime }} - {{ range.EndTime }})
                                            <button type="button" mat-stroked-button color="warn"
                                                (click)="removeRange(range.Id || '')">×</button>
                                        </li>
                                    </ul>
                                </div>
                                <div class="form-row">
                                    <!-- Action Buttons -->
                                    <div class="action-buttons">
                                        <button (click)="clearAllSchedules()" class="clear-btn my-btn"
                                            [disabled]="getCurrentTabDateRanges().length === 0">
                                            Clear All Schedules
                                        </button>
                                        <button (click)="exportSchedules()" class="export-btn my-btn"
                                            [disabled]="getCurrentTabDateRanges().length === 0">
                                            Export Schedule
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- end-->


                        <div *ngIf="false" class="form-row">
                            <div>
                                <label [for]="'courseId-' + i">Course</label>
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Select Course</mat-label>
                                    <mat-select [id]="'courseId-' + i" formControlName="courseId">
                                        <mat-option value="">Select Course</mat-option>
                                        <mat-option *ngFor="let course of courseOptions" [value]="course.id">{{ course.name }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                        <!-- Participants Section -->
                        <!-- <div class="form-row">
                            <div class="form-group">
                                <label class="form-label" [for]="'participants-' + i">Participants(Optional)</label>
                                <input type="text" [id]="'participants-' + i" class="form-control" #participantsInput
                                    placeholder="Enter participants' emails and press Enter"
                                    (keydown.enter)="addParticipant(i, participantsInput); $event.preventDefault()">

                                <div class="participants-list">
                                    <div class="participant-chip" *ngFor="let participant of getParticipantsArray(i)">
                                        {{ participant }} <span class="chip-remove"
                                            (click)="removeParticipantChip(i, participant)">×</span>
                                    </div>
                                </div>
                            </div>
                        </div>-->

                        <div>
                            <div class="two-col-row" style="grid-template-columns: auto 1fr">
                                <div>
                                    <label [for]="'participants-' + i">Participants(Optional)</label>
                                </div>
                                <div>
                                    <mat-form-field appearance="outline" class="w-100">
                                        <mat-label>Enter participants' emails and press Enter</mat-label>
                                        <input matInput type="text" [id]="'participants-' + i"
                                            #participantsInput
                                            (keydown.enter)="addParticipant(i, participantsInput); $event.preventDefault()">
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="participants-list">
                                <div class="participant-chip" *ngFor="let participant of getParticipantsArray(i)">
                                    {{ participant }} <span class="chip-remove"
                                        (click)="removeParticipantChip(i, participant)">×</span>
                                </div>
                            </div>
                        </div>


                        <div class="two-col-row" style="grid-template-columns: auto 1fr">
                            <div>
                                <label [for]="'participants-' + i">Access Via Invited Email
                                    Only</label>
                            </div>
                            <div>
                                <label class="toggle-switch">
                                    <input type="checkbox" formControlName="accessViaInvitedEmailOnly"
                                        (change)="onSliderChange($event)">
                                    <span class="slider"></span>
                                </label>
                            </div>

                        </div>


                        <!-- Trainers Section -->
                        <!-- <div class="form-row">
                            <div class="form-group">
                                <label class="form-label" [for]="'trainers-' + i">Trainers</label>
                                <mat-form-field appearance="outline" class="my-select-box">
                                    <mat-label>Trainers</mat-label>
                                    <mat-select id="trainer" formControlName="trainers" [disabled]="true">
                                        <mat-option *ngFor="let t of trainers" [value]="t.id">{{t.name}}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>-->
                        <div>
                            <div class="two-col-row" style="grid-template-columns: auto 1fr">
                                <div>
                                    <label [for]="'trainers-' + i">Trainers</label>
                                </div>
                                <div>
                                    <mat-form-field appearance="outline" class="my-select-box w-100">
                                        <mat-label>Trainers</mat-label>
                                        <mat-select id="trainer" formControlName="trainers" [disabled]="true">
                                            <mat-option *ngFor="let t of trainers" [value]="t.id">{{t.name}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>



                        <!-- <div class="form-row">
              <div class="form-group">
                <label class="form-label" [for]="'trainersRemarks-' + i">Trainer's Remarks</label>
                <input type="text" [id]="'trainersRemarks-' + i" class="form-control" formControlName="trainersRemarks"
                  placeholder="Trainer's Remarks">
              </div>
            </div> -->

                      <!--  <div class="form-row">
                            <div class="form-group">
                                <label class="form-label" [for]="'trainingDetail-' + i">Training Detail</label>
                                <textarea type="text" [id]="'trainingDetail-' + i" class="form-control"
                                    formControlName="trainingDetail" placeholder="Training detail"></textarea>
                            </div>
                        </div>-->

                        <div>
                            <div class="two-col-row" style="grid-template-columns: auto 1fr">
                                <div>
                                    <label [for]="'trainingDetail-' + i">Training Detail</label>
                                </div>
                                <div>
                                    <mat-form-field appearance="outline" class="w-100">
                                        <mat-label>Training detail</mat-label>
                                        <textarea matInput [id]="'trainingDetail-' + i"
                                            formControlName="trainingDetail"></textarea>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>


                        <!-- Resource Type Selection - Only show when Training Type is 'Instructor-led' -->
                        <!-- <div class="form-row" *ngIf="schedule.get('courseId')?.value == '-1'">
              <div class="form-group full-width">
                <label class="form-label">Resource Type</label>
                <div class="resource-type-panels">
                  <div class="resource-panel" *ngFor="let resourceType of resourceTypes"
                    [class.selected]="getSelectedResourceType(i) === resourceType.value"
                    (click)="selectResourceType(i, resourceType.value)">
                    <img width="80" height="80"
                      [src]="'../../../../assets/images/resources/resource/' + resourceType.value +'.svg'">
                    <div class="panel-label">{{ resourceType.label }}</div>
                  </div>
                </div>
              </div>
            </div> -->

                        <!-- Dynamic Resource Type Controls - Only show when Training Type is 'Instructor-led' -->
                        <!--  <div *ngIf="getSelectedResourceType(i) && schedule.get('courseId')?.value == '-1'"
              class="resource-controls-section">

              <div class="form-row">
                <div class="form-group">
                  <label class="form-label" [for]="'resourceTemplate-' + i">Select Template</label>
                  <div class="selector-box d-flex align-items-center justify-content-between">
                    <mat-form-field appearance="outline" style="width: 250px;" class="my-select-box">
                      <mat-label>Select Template</mat-label>
                      <mat-select formControlName="resourceTemplate"
                        (selectionChange)="selectResourceTemplate(i, $event.value)">
                        <mat-option *ngFor="let rt of resourceTemplates" [value]="rt.id">{{rt.name}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
                <div class="form-group">
                  <label class="form-label">&nbsp;</label>
                  <button title="Add Template" type="button" class="btn btn-outline-success col-md-1 py-2"
                    (click)="createNewVMTemplate()">+</button>
                </div>
              </div>

            </div>-->
                        <!-- <div class="mb-3"> -->
                        <!-- <h6 class="form-label">Resource Deletion Policy</h6> -->
                        <!-- <div class="btn-group w-100 mb-2"> -->
                        <!-- <button type="button" class="p-1 btn" [ngClass]="'btn-primary'" (click)="setRemovalOption('immediate')">
                  Immediate
                </button>
                <button type="button" class="p-1 btn" [ngClass]="'btn-outline-primary'"
                  (click)="setRemovalOption('scheduled')">
                  Scheduled
                </button>
                <button type="button" class="p-1 btn" [ngClass]="'btn-outline-primary'"
                  (click)="setRemovalOption('manual')">
                  Manual
                </button> -->
                        <!-- <div class="btn-group w-100 mb-2">
                <button type="button" class="p-1 btn"
                  [ngClass]="pluginData.TrainingSchedulesData[activeTabIndex].removalOption === 'immediate' ? 'btn-primary' : 'btn-outline-primary'"
                  (click)="setRemovalOption('immediate')">
                  Immediate
                </button>

                <button type="button" class="p-1 btn"
                  [ngClass]="pluginData.TrainingSchedulesData[activeTabIndex].removalOption === 'scheduled' ? 'btn-primary' : 'btn-outline-primary'"
                  (click)="setRemovalOption('scheduled')">
                  Scheduled
                </button>

                <button type="button" class="p-1 btn"
                  [ngClass]="pluginData.TrainingSchedulesData[activeTabIndex].removalOption === 'manual' ? 'btn-primary' : 'btn-outline-primary'"
                  (click)="setRemovalOption('manual')">
                  Manual
                </button>
              </div> -->

                        <!-- </div> -->

                        <!-- Removal Option Specific Controls -->
                        <!-- <div [ngSwitch]="'immediate'"> -->
                        <!-- <div [ngSwitch]="pluginData.TrainingSchedulesData[activeTabIndex].removalOption|| 'immediate'"> -->

                        <!-- Immediate -->
                        <!-- <div *ngSwitchCase="'immediate'" class="mt-2">
                  <div class="alert alert-info py-2 mb-0">
                    <small>Resource will be deleted one(1) hour after training completion, i.e. on {{
                      getDeletionTime() }}</small>
                  </div>
                </div> -->

                        <!-- Scheduled -->
                        <!-- <div *ngSwitchCase="'scheduled'" class="mt-2">
                  <div class="row" [formGroupName]="i">
                    <div class="col-md-4">
                      <label class="small mb-1 fw-semibold">Delete Resource On</label>
                    </div>
                    <div class="col-md-8">
                      <input type="date" id="docDate-{{i}}" class="form-control w-100" formControlName="deletionDate"
                        (change)="onRemovalDateChanged($event, i)">
                    </div>
                  </div>

                </div> -->

                        <!-- Manual -->
                        <!-- <div *ngSwitchCase="'manual'" class="mt-2">
                  <div class="alert alert-warning py-2 mb-0">
                    <small>Resource will be left running on the cloud and will incur billing.</small>
                    <br>
                    <small>Please consider adding a removal date or select immediate removal.</small>
                  </div>
                </div> -->
                        <!-- </div> -->
                        <!-- </div> -->

                    </div>
                </div>
            </div>

            <!-- Step 3: Additional Information -->
            <div class="step-content" *ngIf="currentStep === 3">
                <div formGroupName="additionalInfo">
                    <label class="fw-semibold">Special Requirements</label>
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Any special requirements or instructions</mat-label>
                        <textarea matInput formControlName="specialRequirements" class="textarea"></textarea>
                    </mat-form-field>

                    <label class="fw-semibold">Final Comments</label>
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Additional comments</mat-label>
                        <textarea matInput formControlName="finalComments" class="textarea"></textarea>
                    </mat-form-field>
                </div>
            </div>

        </form>
    </div>

    <!-- Footer -->
    <div class="popup-footer">
        <button type="button" mat-stroked-button (click)="onClose()">Cancel</button>
        <div class="footer-actions">
            <button type="button" mat-stroked-button color="primary" *ngIf="currentStep > 1"
                (click)="previousStep()">Previous</button>
            <button type="button" mat-flat-button color="primary" *ngIf="currentStep < 3" (click)="nextStep()">Next</button>
            <button type="button" mat-flat-button color="primary" *ngIf="currentStep === 3" (click)="onSave()">Save
                Changes</button>
        </div>
    </div>
</div>
<!-- </div> -->